<div class="space-y-6" data-testid="overview-content">
  <h3 class="text-lg font-bold mb-6" data-testid="company-description-header">
    {{ 'project.steps.projectChart.companyAndProjectDescription' | transloco }}
  </h3>
  <div class="space-y-6" data-testid="company-description-sections">
    @for (section of companyDescriptionSections(); track section.key) {
      <div class="space-y-4" [attr.data-testid]="'section-' + section.key">
        <div class="relative w-full">
          <app-rich-text-editor
            [key]="section.key"
            [tooltipKey]="section.tooltipKey"
            [initialContent]="section.content"
            [saveHandler]="richTextService"
            [disabled]="isButtonDisabled()"
            (statusChange)="onStatusChange()"
            class="w-full"
            [attr.data-testid]="'rich-text-editor-' + section.key"
          >
          </app-rich-text-editor>
        </div>
      </div>
    }
  </div>
  <p-divider></p-divider>
  <div class="space-y-4" data-testid="dropdown-selections-section">
    <h3 class="text-lg font-semibold" data-testid="dropdown-selections-header">
      {{ 'project.steps.projectChart.dropdownSelections' | transloco }}
    </h3>
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="dropdown-grid">
      @for (dropdown of dropdowns(); track dropdown.id) {
        <div class="form-field-wrapper" [attr.data-testid]="'dropdown-wrapper-' + dropdown.id">
          <label
            class="block text-sm font-medium mb-1"
            [for]="'dropdown-' + dropdown.id"
            [attr.data-testid]="'dropdown-label-' + dropdown.id"
          >
            {{ dropdown.labelKey | transloco }}
          </label>
          <app-directus-select
            [id]="'dropdown-' + dropdown.id"
            [dropdownKey]="dropdownCollectionName"
            [projectId]="projectId"
            [useStoredValues]="true"
            [preloadedDropdown]="dropdown.data.dropdown"
            [selected]="dropdown.data.value"
            [placeholder]="'common.select' | transloco"
            (valueChange)="onDropdownChange(dropdown.id, $event)"
            [attr.data-testid]="'dropdown-select-' + dropdown.id"
          >
          </app-directus-select>
        </div>
      }
    </div>
    <div class="mt-4 flex justify-end" data-testid="dropdown-save-section">
      @if (canSaveDropdowns()) {
        <app-project-step-save-button
          [loading]="isSaving('dropdowns')"
          [disabled]="isSaving('dropdowns')"
          (clicked)="saveDropdowns()"
        ></app-project-step-save-button>
      }
    </div>
  </div>
  <p-divider></p-divider>
  <div class="space-y-6" data-testid="additional-sections">
    <h3 class="text-lg font-semibold" data-testid="additional-sections-header">
      {{ 'project.steps.projectChart.additionalSections' | transloco }}
    </h3>
    @for (section of additionalSections(); track section.key) {
      <div class="rich-text-section space-y-4" [attr.data-testid]="'section-' + section.key">
        <div class="relative w-full">
          <app-rich-text-editor
            [key]="section.key"
            [initialContent]="section.content"
            [tooltipKey]="section.tooltipKey"
            [saveHandler]="richTextService"
            [disabled]="isButtonDisabled()"
            (statusChange)="onStatusChange()"
            class="w-full"
            [attr.data-testid]="'rich-text-editor-' + section.key"
          >
          </app-rich-text-editor>
        </div>
      </div>
    }
  </div>
</div>
